var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.5V19.5H9.42225L11.4608 21.54L12.0007 22.0545L12.5408 21.5392L14.5778 19.5H21.75V4.5H2.25ZM3.75 6H20.25V18H13.9455L13.7108 18.21L12 19.9222L10.29 18.2123L10.0545 18.0007H3.75V6ZM6.75 8.25V9.75H17.25V8.25H6.75ZM6.75 11.25V12.75H17.25V11.25H6.75ZM6.75 14.25V15.75H14.25V14.25H6.75Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsIconActive);
export default __webpack_public_path__ + "static/media/commentsIconActive.e1201acf7158f64a3ee780fd027ee75b.svg";
export { ForwardRef as ReactComponent };